import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
const PaymentModelToDisplayNameMapping = {
  [MarketplaceAppPaymentModel.Free]: 'Free',
  [MarketplaceAppPaymentModel.PaidViaAtlassian]: 'Paid via Atlassian',
  [MarketplaceAppPaymentModel.PaidViaPartner]: 'Paid via Vendor'
};
export const mapPaymentModelToDisplayValue = paymentModel => {
  return PaymentModelToDisplayNameMapping[paymentModel];
};